import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import LocalizacaoBlockView from './View';

const LocalizacaoBlockEdit = (props) => {
  return (
    <>
      <LocalizacaoBlockView {...props} isEditMode />
    </>
  );
};

export default withBlockExtensions(LocalizacaoBlockEdit);
